// extracted by mini-css-extract-plugin
module.exports = {"headNav":"styles-module--headNav--1Wusv"};